// CompanyRegistration.jsx
import React from "react";

export default function CompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Company Registration Support in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides end-to-end professional support for
            Company Registration in India, ensuring full compliance with the
            Companies Act and MCA regulations. Our experts guide you through
            legal structuring, documentation, and statutory requirements to
            help establish a fully compliant and legally recognized company.
          </p>
          <p className="text-gray-700">
            From choosing the right type of entity to filing forms with the
            Ministry of Corporate Affairs, the process is handled in a
            structured and transparent manner so that you can focus on building
            your business.
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Corporate professionals discussing company registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in preparing, verifying, and
              organizing all the documents required for smooth company
              incorporation, reducing the chances of rejection or resubmission.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of directors and shareholders</li>
                <li>
                  Identity proof of directors and shareholders (Aadhaar, Passport,
                  Voter ID, or Driving License)
                </li>
                <li>
                  Address proof of directors and shareholders (bank statement,
                  utility bill, etc.)
                </li>
                <li>Registered office address proof (rent agreement or ownership proof)</li>
                <li>Recent passport-size photographs</li>
                <li>Digital Signature Certificate (DSC) of proposed directors</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The company offers specialized assistance in Indian corporate
              compliance, reducing errors and delays in the registration
              process.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Indian Corporate Laws
                </h3>
                <p className="text-gray-700 text-sm">
                  Team familiar with Companies Act, MCA procedures, and changing
                  compliance standards, ensuring your company structure and
                  filings are legally aligned.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation &amp; Filing
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support in drafting, reviewing, and filing
                  incorporation documents to minimize resubmissions and
                  rejection risks.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Transparent &amp; Professional Process
                </h3>
                <p className="text-gray-700 text-sm">
                  Clear timelines, transparent pricing, and continuous updates
                  at every stage of company registration for a hassle-free
                  experience. Dedicated assistance throughout the registration process
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
